import React from 'react';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/styles';
import { Trans, withTranslation } from 'react-i18next';
import { PriorityHigh } from '@material-ui/icons';
import styles from '../../../assets/jss/FormStyle';
import GridContainer from '../../../assets/jss/GridContainer';
import CModal from '../../Utils/CModal';
import SettingsIcon from '../../../helper/subMneuIcon/SettingsIcon';

function U2fInsertDeviceModal(props) {
  const {
    classes,
    id,
    open,
    closeModel,
  } = props;

  return (
    <React.Fragment key={id}>
      <CModal
        title="SETTINGS.U2F_VERIFY"
        open={open}
        crossIcon
        handleClose={closeModel}
        id={id}
        icon={<SettingsIcon />}
        headerIcon={<SettingsIcon />}
      >
        <GridContainer className={classes.extraTopMargin}>
          <Grid item xs={12} sm={12} className={classes.insertDriveModal}>
            <p>
              <span><PriorityHigh /></span>
              {' '}
              <Trans>INFO.U2F_TEXT</Trans>
            </p>
          </Grid>
        </GridContainer>
      </CModal>
    </React.Fragment>
  );
}

export default withTranslation()(withStyles(styles, { withTheme: true })(U2fInsertDeviceModal));
